import { create } from 'zustand'

interface AlertIndicationState {
  showMutedAlertIndication: boolean
  setShowMutedAlertIndication: (value: boolean) => void
}

export const useAlertIndicationStore = create<AlertIndicationState>(set => ({
  showMutedAlertIndication: (() => {
    try {
      const saved = localStorage.getItem('showMutedAlertIndication')
      return saved !== null ? JSON.parse(saved) : true
    } catch {
      return true
    }
  })(),
  setShowMutedAlertIndication: (value: boolean) => {
    localStorage.setItem('showMutedAlertIndication', JSON.stringify(value))
    set({ showMutedAlertIndication: value })
  },
}))
